var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.authenticated)?_vm._t("default"):_vm._e(),(_vm.hasError)?_vm._t("login-error",null,{"errorMessage":_vm.errorMessage}):_vm._e(),(!_vm.authenticated && !_vm.hasError)?_vm._t("login-progress"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }